
<template>
    <div>
        <div id="carouselExampleCaption" class="carousel slide" data-ride="carousel" style="height: 730px;"
            data-interval="10000">
            <div class="carousel-inner carousel-fade" role="listbox">
                <ol class="carousel-indicators">
                    <li data-target="#carouselExampleCaption" data-slide-to="0" class="active"></li>
                    <li data-target="#carouselExampleCaption" data-slide-to="1" class=""></li>
                    <li data-target="#carouselExampleCaption" data-slide-to="2" class=""></li>
                    <li data-target="#carouselExampleCaption" data-slide-to="3" class=""></li>
                </ol>
                <ul class="carousel-indicators d-inline bubbles">
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                </ul>
                <div class="carousel-item active">
                    <section class="section hero-section bg-ico-home-2">
                        <div class="container">
                            <div class="row align-items-center text-center">
                                <div class="col-12 col-lg-8 d-lg-none">
                                    <img src="awan/images/particle-2.webp" alt="bayar-tagihan-apa-aja-bisa-di-awan"
                                        class="img-fluid w-50">
                                </div>
                                <div class="col-12 col-lg-4">
                                    <div class="text-white-50">
                                        <h1 class="text-white font-weight-semibold mb-3 hero-title"
                                            style="font-family: 'Baloo Paaji'">Bayar Tagihan apa aja bisa di Awan!</h1>
                                        <p class="font-size-16 text-light">Mulai dari bayar tagihan Listrik, Air PDAM,
                                            BPJS, Telkom, Token Listrik, Internet hingga Transfer uang ke rekening Bank,
                                            semua bisa dilayani dengan cepat dan mudah menggunakan APlikasi AWAN. Gabung
                                            dan dapatkan keuntungannya Sekarang!</p>
                                        <div class="button-items mt-4">
                                            <a href="https://play.google.com/store/apps/details?id=com.awan"
                                                target="blank" data-aos="fade-left playstore">
                                                <img src="awan/images/google-play-store-badge.svg" alt="Google Play">
                                            </a>
                                            <a href="https://apps.apple.com/id/app/awan-ppob-pulsa-tagihan/id6480331409"
                                                target="blank" data-aos="fade-left">
                                                <img src="awan/images/apple-store-badge.svg" alt="App">
                                            </a>
                                            <!-- <a href="https://docs.awanbisnis.com/" data-aos="fade-left" class="btn btn-warning"><i class="bx bx-help-circle"></i> Panduan Lengkap</a> -->
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-8 d-lg-inline d-none">
                                    <img src="awan/images/particle-2.webp" alt="bayar-tagihan-apa-aja-bisa-di-awan"
                                        class="img-fluid">
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <div class="carousel-item">
                    <section class="section hero-section bg-ico-home-1">
                        <div class="container">
                            <div class="row align-items-center text-center text-lg-left">
                                <div class="col-12 col-lg-8 d-lg-none">
                                    <img src="awan/images/particle-1.webp" alt="awan-hands-on-secara-portable-ditangan"
                                        class="img-fluid w-50 d-lg-none d-inline">
                                </div>
                                <div class="col-12 col-lg-4">
                                    <div class="text-white-50">
                                        <h1 class="text-white font-weight-semibold mb-3 hero-title" data-aos="fade-up"
                                            style="font-family: 'Baloo Paaji'">Hai, Kawan!</h1>
                                        <p class="font-size-16 text-light" data-aos="fade-left">Perkenalkan AWAN,
                                            Aplikasi pintar untuk meningkatkan efisiensi dan keuntungan usaha kamu
                                            dengan melayani Pembayaran PPOB!</p>
                                        <p class="font-size-14 text-white-80" data-aos="fade-left">Daftar sekarang dan
                                            mulai tingkatkan pendapatan usaha kamu hingga jutaan rupiah.</p>
                                        <div class="button-items mt-4">
                                            <a href="https://play.google.com/store/apps/details?id=com.awan"
                                                target="blank" data-aos="fade-left playstore">
                                                <img src="awan/images/google-play-store-badge.svg" alt="Google Play">
                                            </a>
                                            <a href="https://apps.apple.com/id/app/awan-ppob-pulsa-tagihan/id6480331409"
                                                target="blank" data-aos="fade-left">
                                                <img src="awan/images/apple-store-badge.svg" alt="App">
                                            </a>
                                            <!-- <a href="https://docs.awanbisnis.com/" data-aos="fade-left" class="btn btn-warning"><i class="bx bx-help-circle"></i> Panduan Lengkap</a> -->
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-8 d-lg-inline d-none">
                                    <img src="awan/images/particle-1.webp" alt="awan-hands-on-secara-portable-ditangan"
                                        class="img-fluid w-100">
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <div class="carousel-item">
                    <section class="section hero-section bg-ico-home-3">
                        <div class="container">
                            <div class="row align-items-center text-center">
                                <div class="col-12 col-lg-5 d-lg-none">
                                    <img src="awan/images/object-8.webp" alt="beli-pulsa-dengan-mudah"
                                        class="img-fluid w-50 d-lg-none d-inline">
                                </div>
                                <div class="col-12 col-lg-7">
                                    <h1 class="text-white font-weight-bold mb-5 hero-title"
                                        style="font-family: 'Baloo Paaji'">Beli pulsa dan paket data lengkap dan mudah
                                    </h1>
                                    <p class="font-size-16 text-light">Semua pelanggan butuh pulsa, semua aplikasi butuh
                                        paket Data. Dan semuanya bisa dilayani menggunakan Aplikasi AWAN. Menyediakan
                                        Pulsa All Operator dengan denom lengkap serta pilihan paket data yang lengkap
                                        dan murah. Pelanggan happy, keuntungan sudah pasti!</p>
                                    <div class="button-items mt-4">
                                        <a href="https://play.google.com/store/apps/details?id=com.awan"
                                                target="blank" data-aos="fade-left playstore">
                                                <img src="awan/images/google-play-store-badge.svg" alt="Google Play">
                                            </a>
                                            <a href="https://apps.apple.com/id/app/awan-ppob-pulsa-tagihan/id6480331409"
                                                target="blank" data-aos="fade-left">
                                                <img src="awan/images/apple-store-badge.svg" alt="App">
                                            </a>
                                        <!-- <a href="https://docs.awanbisnis.com/" data-aos="fade-left" class="btn btn-warning"><i class="bx bx-help-circle"></i> Panduan Lengkap</a> -->
                                    </div>
                                </div>
                                <div class="col-12 col-lg-5 d-none d-lg-inline">
                                    <img src="awan/images/object-8.webp" alt="beli-pulsa-dengan-mudah"
                                        class="img-fluid w-100 d-lg-inline d-none">
                                </div>

                            </div>
                        </div>
                    </section>
                </div>
                <div class="carousel-item">
                    <section class="section hero-section bg-ico-home-3">
                        <div class="container">
                            <div class="row align-items-center text-center">
                                <div class="col-12 col-lg-4">
                                    <img src="awan/images/object-7.webp"
                                        alt="Aplikasi-Pembukuan-AWAN-praktis-dan-memudahkan"
                                        class="img-fluid w-100 d-lg-inline d-none">
                                    <img src="awan/images/object-7.webp"
                                        alt="Aplikasi-Pembukuan-AWAN-praktis-dan-memudahkan"
                                        class="img-fluid w-50 d-inline d-lg-none">
                                </div>
                                <div class="col-12 col-lg-8">
                                    <h1 class="text-white font-weight-bold mb-5 hero-title"
                                        style="font-family: 'Baloo Paaji'">Aplikasi Pembukuan AWAN praktis dan
                                        memudahkan.
                                    </h1>
                                    <p class="font-size-16 text-light">Catat Stok lebih rapi, atur harga dan simpan data
                                        penjualan dengan mudah, pantau laporan usaha dengan lebih nyaman dan efisien,
                                        semua bisa dilakukan dengan Aplikasi AWAN. Aplikasi Pembukuan untuk UMKM
                                        membantu usaha kamu jadi lebih rapi dan menguntungkan!</p>
                                    <div class="button-items mt-4">
                                        <a href="https://play.google.com/store/apps/details?id=com.awan"
                                                target="blank" data-aos="fade-left playstore">
                                                <img src="awan/images/google-play-store-badge.svg" alt="Google Play">
                                            </a>
                                            <a href="https://apps.apple.com/id/app/awan-ppob-pulsa-tagihan/id6480331409"
                                                target="blank" data-aos="fade-left">
                                                <img src="awan/images/apple-store-badge.svg" alt="App">
                                            </a>
                                        <!-- <a href="https://docs.awanbisnis.com/" data-aos="fade-left" class="btn btn-warning"><i class="bx bx-help-circle"></i> Panduan Lengkap</a> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>

            <a class="carousel-control-prev" href="#carouselExampleCaption" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#carouselExampleCaption" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
            </a>
        </div>

        <!-- Features start -->
        <section class="section bg-white">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-12">
                        <div data-aos="fade-right">
                            <img src="awan/images/object-1.webp" alt="jualan-pintar-makin-cuan"
                                class="img-fluid mx-auto d-block">
                        </div>
                    </div>
                    <div class="col-lg-6 col-12">
                        <div class="mt-4 mt-md-auto text-center">
                            <h1 class="text-center font-weight-bold mb-3 hero-title" data-aos="fade-up"
                                style="font-family: 'Baloo Paaji'; color: #233dff">Jualan Pintar <br>Makin CUAN</h1>
                            <br>
                            <span class="font-size-16" data-aos="fade-left">AWAN menyediakan Aplikasi Kasir yang sesuai
                                dengan kebutuhan usaha kamu seperti usaha warung, toko, rumah makan, toko elektronik,
                                salon kecantikan dan usaha lainnya. AWAN juga dilengkapi fitur pembayaran tagihan
                                bulanan atau PPOB seperti Pembayaran PLN, PDAM, BPJS, Token Listrik, Pulsa dan kebutuhan
                                digital lainnya.</span>
                            <div class="mt-5 text-center">
                                <img src="awan/images/particle-object-1.svg" width="80"
                                    class="img-fluid mx-auto d-inline" data-aos="fade-left">
                                <img src="awan/images/particle-object-1.svg" width="80"
                                    class="img-fluid mx-auto d-inline" data-aos="fade-up">
                                <img src="awan/images/particle-object-1.svg" width="80"
                                    class="img-fluid mx-auto d-inline" data-aos="fade-right">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section" style="background-color: #233dff;">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-12">
                        <div class="mt-4 mt-md-auto  text-center">
                            <h1 class="text-light font-weight-bold mb-3 hero-title" data-aos="fade-up"
                                style="font-family: 'Baloo Paaji'">Kenapa usahamu<br>harus pakai awan?</h1>
                            <br>
                            <span class="font-size-16 text-light" data-aos="fade-up">Alasan kenapa kamu harus
                                berbisnis PPOB Awan dan sudah dibuktikan ratusan ribu orang.Pasar kamu adalah
                                orang-orang disekitarmu yang punya kebutuhan bayar tagihan dan kebutuhan digital
                                lainnya.Semua orang yang punya rumah atau tempat tinggal pasti bayar tagihan, mulai dari
                                bayar
                                listrik, token listrik, tagihan PDAM, BPJS Kesehatan, Pulsa, Cicilan kredit, dll.
                            </span>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div data-aos="fade-up">
                            <img src="awan/images/object-2-1.webp" alt="potensi-pasar-penjualan-produk-digital"
                                class="img-fluid mx-auto d-block">
                        </div>
                    </div>
                </div>
                <div class="row align-items-center">
                    <div class="col-12">
                        <div class="mt-4 mt-md-auto">
                            <h1 class="text-light text-center font-weight-bold mb-3 hero-title" data-aos="fade-up"
                                style="font-family: 'Baloo Paaji'">Ribuan UMKM sudah jadi kawan awan.<br>Usahamu kapan?
                            </h1>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="col-lg-12">
                            <div class="row">
                                <div class="col-lg-4" data-aos="fade-up">
                                    <img src="awan/images/testi-1.webp"
                                        alt="aplikasi-bagus-transaksi-cepat-dan-struknya-bisa-dibagikan-via-whatsapp"
                                        class="img-fluid mx-auto d-block">
                                </div>
                                <div class="col-lg-4" data-aos="fade-up">
                                    <img src="awan/images/testi-2.webp"
                                        alt="awan-sangat-memudahkan-dalam-mengatur-keuangan-terutama-bagi-pelaku-UMKM"
                                        class="img-fluid mx-auto d-block">
                                </div>
                                <div class="col-lg-4" data-aos="fade-up">
                                    <img src="awan/images/testi-3.webp"
                                        alt="menu-pembayaran-ppob-lengkap-sangat-bermanfaat-untuk-melengkapi-usaha-toko/warung"
                                        class="img-fluid mx-auto d-block">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row align-items-center" data-aos="fade-up">
                    <div class="col-md-12 ml-auto">
                        <div class="mt-4 mt-md-auto">
                            <img src="awan/images/object-6.webp" alt="modal-minimal-cuan-maksimal"
                                class="img-fluid mx-auto d-block">
                        </div>
                    </div>
                </div>
                <div class="row align-items-center" data-aos="fade-up">
                    <div class="col-md-12 ml-auto">
                        <div class="mt-4 mt-md-auto">
                            <img src="awan/images/object-5.webp" alt="4-langkah-mudah-bisnis-sendiri"
                                class="img-fluid mx-auto d-block">
                        </div>
                    </div>
                </div>
                <div class="row align-items-center" data-aos="fade-up">
                    <div class="col-md-12 ml-auto">
                        <div class="mt-4 mt-md-auto">
                            <img src="awan/images/object-4.webp" alt="topup-saldo-di-awan-dengan-mudah-dan-aman"
                                class="img-fluid mx-auto d-block">
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section bg-white" id="news" data-aos="fade-up">
            <div class="px-3 px-sm-5">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="text-center mb-5">
                            <h1 class="text-center font-weight-bold mb-3 hero-title"
                                style="font-family: 'Baloo Paaji'; color: #233dff">Ruang Berita</h1>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-4 col-lg-6" v-for="item in blogs">
                        <div class="blog-box mb-4 mb-xl-0" @click="goDetail(item.slug)">
                            <div class="position-relative">
                                <img :src="item.image" :alt="item.slug" class="rounded img-fluid mx-auto d-block">
                                <div class="badge badge-success blog-badge font-size-11">{{ item.tag }}</div>
                            </div>
                            <div class="mt-4 text-muted">
                                <p class="mb-2"><i class="bx bx-calendar mr-1"></i> {{ item.created_at.replace('T', ' ')
                                    }}
                                </p>
                                <h5 class="mb-3">{{ item.title }}</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section" style="background-color: #233dff;">
            <a href="https://wa.me/6281529430000">
                <div data-aos="fade-right">
                    <img src="awan/images/helpdesk-1.webp" alt="butuh-bantuan-helpdesk-awan-siap-membantu"
                        class="img-fluid mx-auto d-block">
                </div>
            </a>
        </section>
        <section class="section bg-white mb-0 mt-0">
            <div data-aos="fade-right">
                <img src="awan/images/upgrade.webp" alt="upgrade-bisnis-kamu-sekarang"
                    class="img-fluid mx-auto d-block">
            </div>
        </section>
    </div>
</template>
<script>
export default {
    name: 'Home',
    components: {
    },
    data() {
        return {
            blogs: [],
        }
    },
    methods: {
        goDetail(slug) {
            this.$router.push({ name: 'BlogDetail', params: { slug: slug } })
        },
        getBlog() {
            axios.get('v1/get_blogs', {
                params: {
                    limit: 3,
                    sort: 'DESC',
                    hide_description: false
                }
            }).then((response) => {
                this.blogs = response.data
            })
        }
    },
    mounted() {
        this.$Progress.start()
        AOS.init({
            easing: 'ease-out-back',
            duration: 2000,
        });
        this.getBlog()
        this.$Progress.finish()
    },
}
</script>